import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-[#0f172a] to-[#1e293b] text-white border-t-2 border-[#e2b13c]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Colonne 1 : À propos */}
          <div>
            <h3 className="text-[#e2b13c] font-bold text-lg mb-4 uppercase tracking-wide">VTC des Weppes</h3>
            <p className="text-sm text-gray-300 leading-relaxed">
              Votre chauffeur privé de confiance à Beaucamps-Ligny et dans toute la région des Hauts-de-France. 
              L'humain avant l'algorithme.
            </p>
            <div className="mt-4">
              <p className="text-xs text-gray-400">SAS VTC des Weppes</p>
              <p className="text-xs text-gray-400">59134 Beaucamps-Ligny</p>
              <p className="text-xs text-gray-400">SIRET : 918 489 659 00014</p>
            </div>
          </div>

          {/* Colonne 2 : Contacts */}
          <div>
            <h3 className="text-[#e2b13c] font-bold text-lg mb-4 uppercase tracking-wide">Contacts</h3>
            <div className="space-y-3">
              <div>
                <p className="text-sm font-semibold text-white">🚨 Urgence Patrick</p>
                <a href="tel:0695731320" className="text-[#e2b13c] hover:text-[#d4a434] transition-colors">
                  06 95 73 13 20
                </a>
              </div>
              <div>
                <p className="text-sm font-semibold text-white">📞 Bureau Catherine</p>
                <a href="tel:0967562673" className="text-[#e2b13c] hover:text-[#d4a434] transition-colors">
                  09 67 56 26 73
                </a>
              </div>
              <div>
                <p className="text-sm font-semibold text-white">📧 Email</p>
                <a href="mailto:contact@vtcdesweppeslille.fr" className="text-[#e2b13c] hover:text-[#d4a434] transition-colors">
                  contact@vtcdesweppeslille.fr
                </a>
              </div>
            </div>
          </div>

          {/* Colonne 3 : Liens légaux */}
          <div>
            <h3 className="text-[#e2b13c] font-bold text-lg mb-4 uppercase tracking-wide">Informations Légales</h3>
            <div className="space-y-2">
              <Link to="/mentions-legales" className="block text-sm text-gray-300 hover:text-[#e2b13c] transition-colors">
                Mentions Légales
              </Link>
              <Link to="/cgv-rgpd" className="block text-sm text-gray-300 hover:text-[#e2b13c] transition-colors">
                CGV & RGPD
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-700 text-center">
          <p className="text-xs text-gray-400">
            © {new Date().getFullYear()} VTC des Weppes - Tous droits réservés
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;